<ng-template cxOutletRef="CustomerServiceContent" cxOutletPos="after">
  <!-- Customer Service Content (mobile view) -->
  <!-- MOBILE FAQ-->
  <div
    class="customer-service-content-mobile d-md-none"
    *ngIf="isMobile && customerServiceSectionFaq$ | async as customerServiceSectionFaq"
  >
    <div class="customer-service-content-faq-details">
      <h2 class="mb3">{{ customerServiceSectionFaq.title }}</h2>
      <div
        class="faq-dropdown-container d-inline-block"
        display="dynamic"
        placement="bottom-left"
        ngbDropdown
        *ngIf="customerServiceSectionFaqData$ | async as customerServiceSectionFaqData"
      >
        <button
          *ngIf="customerServiceSectionFaqData[activeI]?.title"
          class="btn btn-link p-0"
          id="faqDropdown"
          ngbDropdownToggle
        >
          {{ customerServiceSectionFaqData[activeI].title }}
          <mat-icon class="material-icons-sharp light md-12 ml-1">expand_more</mat-icon>
        </button>
        <div ngbDropdownMenu aria-labelledby="faqDropdown" class="dropdown-menu dropdown-menu-right border-0 rounded-0">
          <button
            ngbDropdownItem
            (click)="onSelectFaqData(faqGroup, i); activeI = i"
            *ngFor="let faqGroup of customerServiceSectionFaqData; let i = index"
            [class.selected]="activeI === i"
          >
            <mat-icon svgIcon="check" class="md-12 mr-2" *ngIf="activeI === i"></mat-icon> {{ faqGroup.title }}
          </button>
        </div>
      </div>
      <app-accordion
        [list]="customerServiceSectionFaqAccordionData"
        *ngIf="
          customerServiceSectionFaqAccordionData$ | async as customerServiceSectionFaqAccordionData;
          else faqAccordionData0
        "
      ></app-accordion>
      <ng-template #faqAccordionData0>
        <ng-container *ngIf="customerServiceContentData$ | async as customerServiceContentData">
          <app-accordion
            [list]="customerServiceContentData"
            *ngIf="lodash.includes(customerServiceContentData[0].typeCode, 'Accordion')"
          ></app-accordion>
        </ng-container>
      </ng-template>
    </div>
  </div>
  <!-- MOBILE LINKS-->
  <div
    class="customer-service-content-mobile d-md-none"
    *ngIf="isMobile && customerServiceSectionLinks$ | async as customerServiceSectionLinks"
  >
    <div class="customer-service-content-links-details">
      <h2 class="mb-3">{{ customerServiceSectionLinks.title }}</h2>
      <ng-container *ngIf="customerServiceSectionLinksData$ | async as customerServiceSectionLinksData">
        <cx-generic-link
          class="d-block mb-3"
          *ngFor="let link of customerServiceSectionLinksData; let i = index"
          [url]="link.url"
          [target]="link.target"
          >{{ link.linkName }}</cx-generic-link
        >
      </ng-container>
    </div>
  </div>
  <!-- MOBILE CONTACT US-->
  <div
    class="customer-service-content-mobile d-md-none"
    *ngIf="isMobile && customerServiceSectionContactUs$ | async as customerServiceSectionContactUs"
  >
    <div
      class="customer-service-content-contact-us-details form"
      *ngIf="customerServiceSectionContactUsContentData$ | async as customerServiceSectionContactUsContentData"
    >
      <h2 class="mb-3">{{ customerServiceSectionContactUs.title }}</h2>
      <ng-container
        [ngTemplateOutlet]="contactUsTemplate"
        [ngTemplateOutletContext]="{ posData: customerServiceSectionContactUsContentData[1] }"
      ></ng-container>
    </div>
  </div>

  <!-- Customer Service Content (desktop view) -->
  <div
    class="d-none d-md-block"
    [class.customer-service-content]="lodash.includes(customerServiceContentData[0].typeCode, 'Accordion')"
    [class.form]="!lodash.includes(customerServiceContentData[0].typeCode, 'Accordion')"
    [class.customer-service-content-contact-us-details]="
      !lodash.includes(customerServiceContentData[0].typeCode, 'Accordion')
    "
    *ngIf="!isMobile && customerServiceContentData$ | async as customerServiceContentData"
  >
    <app-accordion
      [list]="customerServiceContentData"
      *ngIf="lodash.includes(customerServiceContentData[0].typeCode, 'Accordion'); else contactUs"
    ></app-accordion>
    <ng-template #contactUs>
      <ng-container
        [ngTemplateOutlet]="contactUsTemplate"
        [ngTemplateOutletContext]="{ posData: customerServiceContentData[1] }"
      ></ng-container>
    </ng-template>
  </div>
</ng-template>

<ng-template #contactUsTemplate let-posData="posData">
  <app-dynamic-form
    (formGroupEmit)="updateFormGroup($event)"
    (formModelEmit)="updateFormModel($event)"
    [emitOnInit]="true"
    [formGroupId]="'CONTACT_US'"
    [static]="false"
    [activeLanguage]="activeLanguage$ | async"
    [ngClass]="activeLanguage$ | async"
  ></app-dynamic-form>
  <div class="submit-form-container d-flex justify-content-end">
    <button
      type="button"
      class="btn primary-btn"
      (click)="onSubmitContactUsForm()"
      [class.disabled]="!contactUsFormGroup?.valid || onSubmitContactUsFormInProgress"
      [disabled]="!contactUsFormGroup?.valid || onSubmitContactUsFormInProgress"
      [ngClass]="{
        rotating: onSubmitContactUsFormInProgress
      }"
    >
      {{ onSubmitContactUsFormInProgress ? '' : ('common.submit' | cxTranslate) }}
    </button>
  </div>
  <div class="points-of-service-container" *ngIf="pointsOfService?.length > 0">
    <h3>{{ posData.title }}</h3>
    <div class="d-flex flex-wrap w-100">
      <div
        class="point-of-service-container"
        *ngFor="let point of pointsOfService | slice : 0 : posData.itemCount; let i = index"
      >
        <div class="point-of-service-details-container">
          <h4 class="mb-1">{{ point.displayName || point.name }}</h4>
          <span class="d-block value">{{ point.address.formattedAddress }}</span>

          <ng-container *ngIf="point.address.phone">
            <span class="mr-1 title">{{ 'customerService.phone' | cxTranslate }}</span>
            <span class="value">{{ point.address.phone }}</span>
          </ng-container>

          <div class="contact-us-email">
            <span class="mr-1 title" [class.ml-2]="point.address.phone">{{
              'customerService.email' | cxTranslate
            }}</span>
            <span class="value">{{ point.address.email }}</span>
          </div>

          <div class="contact-us-fax" *ngIf="point?.address?.fax">
            <span class="mr-1 title" [class.ml-2]="point.address.fax">{{ 'customerService.fax' | cxTranslate }}</span
            ><span class="value">{{ point.address.fax }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
